import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database, withLogs } from '@core';

const GUIDE_SELECT = `
    id,
    time_series_measurement_id,
    guideContent:i18n_markdown_key,
    axes:user_guide_axes(
        id,
        axis,
        axisContent:i18n_markdown_key,
        negativeMeaning:negative_meaning_i18n_markdown_key,
        positiveMeaning:positive_meaning_i18n_markdown_key,
        parameters:user_guide_parameters(
            id,
            p_position,
            parameterContent:i18n_markdown_key
        )
    )
`;

export type UserGuide = Awaited<ReturnType<typeof fetchPublishedGuides>>;

export const fetchPublishedGuides = withLogs(async (supabaseClient: SupabaseClient<Database>) => {
    const { data, error } = await supabaseClient.from('user_guides').select(GUIDE_SELECT).eq('is_draft', false);

    if (error) throw error;

    return camelcaseKeys(data, { deep: true });
}, 'fetchPublishedGuides');
